import React, { useState, useEffect } from "react";
import "./index.scss";
import SuccessModal from "../../../reusableComponents/SuccessModal";
import ErrorModal from "../../../reusableComponents/ErrorModal";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { removeLastPayment, setPaymentStatus } from "../../../store/reducers/accountSlice";

function PostPayment({ status }) {
  const challengeId = useSelector((state) => state.account.selectedChallenge);
  console.log(useSelector(state=>state),'dklfjkldjfkjd')

  const paymentHistory = useSelector((state) => state.account.paymentHistory);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isModalOpen, setModalOpen] = useState(true);
  const handleModal = (status) => {
    if (status === "success") {
      // stats api call on success
      window.fbq("track", "Purchase", { currency: "USD", value: paymentHistory?.lastPayment?.data?.amount });
      navigate("/funding-evaluation-payment/payment-history/");
      dispatch(setPaymentStatus(true))
    } else if (status === "failure") {
      navigate(`/funding-evaluation/payments/${challengeId}`);
      dispatch(setPaymentStatus(false))
    }
    setModalOpen(false);
  };
  useEffect(() => {
    handleModal(status)
  }, [status])

  const accountList = useSelector((state) => state?.account?.accountList?.data)
  let msg = accountList?.length > 0 ? "Congratulations! Payment was successful" : "You'll shortly receive an email with your account login credentials"
  return status === "" && isModalOpen ? (
      <SuccessModal
        setModalOpen={() => handleModal(status)}
        title="Successful!"
        desc={msg}
        btnText="Close"
      />
    ) : status === "failure" && isModalOpen ? (
      <ErrorModal
        setModalOpen={() => handleModal(status)}
        desc="Payment Failed. Try again later."
        btnText="Close"
      />
  ): null;
}

export default PostPayment;
